<template>
  <section>

    <div class="d-flex justify-content-end mb-3">
      <!-- <b-button @click="openPaymentsModal" size="sm" variant="primary">
        <i class="fa fa-plus" aria-hidden="true"></i>
        Add New
      </b-button> -->
    </div>
    <grid-component
        isResizable
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :onDelete="onDeletingPaymentLine"
     />
    <b-modal id="delete-payments-modal" ref="delete-payments-modal" title="Delete Payment" centered :ok-disabled="deleteBtnDisabled || isGettingDetails" ok-title="Delete Payment" @ok="deletePayment">
      <div v-if="isGettingDetails">
        <b-alert variant="info" show style="text-align: center" ><strong>Getting Payment Details...</strong></b-alert>  
      </div>      
      <div v-else>
        <details-component />
        <br/>
        <h5>Deleting this payment will reverse the transaction shown above</h5>
      </div>
    </b-modal>
    <!-- <b-modal
      id="payments-modal"
      ref="payments-modal"
      title="Payments"
      centered
      :ok-disabled="okButtonDisabled"
      @ok="addPayment"
    >
      <h6>Use this form to enter customer payment details.</h6>
      <b-row>
        <b-col>
          <b-form-group label="Date">
            <date-picker v-model="paymentObj.paymentDate" :class="{ 'is-invalid': $v.paymentObj.paymentDate.$error }" :config="datePickerOptions" @blur="$v.paymentObj.paymentDate.$touch()"></date-picker>
            <div class="invalid-feedback">
              <div v-if="!$v.paymentObj.paymentDate.required">Payment Date is required</div>
            </div>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Payment Method">
            <b-form-select v-model="paymentObj.paymentMethodId" :class="{ 'is-invalid': $v.paymentObj.paymentMethodId.$error }" @blur="$v.paymentObj.paymentMethodId.$touch()">
              <option v-for="method in sortSelect(paymentMethods)" :key="method.id" :value="method.id">
                {{method.name}}
              </option>
            </b-form-select>
            <div class="invalid-feedback">
              <div v-if="!$v.paymentObj.paymentMethodId.required">Payment Method is required</div>
            </div>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Amount" >
            <b-input-group prepend="$" size="sm">
              <b-form-input v-model.number="paymentObj.amount" :class="{ 'is-invalid': $v.paymentObj.amount.$error }" @blur="$v.paymentObj.amount.$touch()" type="number" min="0"></b-form-input>
            </b-input-group>
            <div class="invalid-feedback">
              <div v-if="!$v.paymentObj.amount.required">Amount is required</div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Reference Number">
            <b-form-input v-model="paymentObj.referenceNumber"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Memo">
            <b-form-input v-model="paymentObj.comments"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <h6>Expenses details.</h6>
      <b-row>
        <b-col>
          <b-form-group label="Type" class="mr-2">
            <b-form-select v-model="expenseObj.accountId" :class="{ 'is-invalid': $v.expenseObj.accountId.$error }" @blur="$v.expenseObj.accountId.$touch()">
              <option
                v-for="source in sortSelect(chartOfAccounts,'accountName')"
                :key="source.id"
                :value="source.id"
              >{{source.accountName}}
              </option>
            </b-form-select>
            <div class="invalid-feedback">
              <div v-if="!$v.expenseObj.accountId.required">Type is required</div>
            </div>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Description" class="mr-2">
            <b-form-input v-model="expenseObj.description"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Amount" prepend="$" class="mr-2">

            <b-form-input v-model.number="expenseObj.amount" :class="{ 'is-invalid': $v.expenseObj.amount.$error }" @blur="$v.expenseObj.amount.$touch()" type="number" min="0"></b-form-input>
          </b-form-group>

          <b-form-group label="Amount" >

            
            <b-input-group prepend="$" size="sm">
              <b-form-input v-model.number="expenseObj.amount" :class="{ 'is-invalid': $v.expenseObj.amount.$error }" @blur="$v.expenseObj.amount.$touch()" type="number" min="0"></b-form-input>
            </b-input-group>
            <div class="invalid-feedback">
              <div v-if="!$v.paymentObj.amount.required">Amount is required</div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal> -->
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import gridFields from './fields';
import GridComponent from '@/shared/components/GridComponent';
import { DATE_FORMAT, GRID_ID } from '@/shared/constants';
import { decimal, required } from 'vuelidate/lib/validators';
import { numberGreaterThan } from '@/shared/validators';
import DetailsComponent from './components/details';

export default {
  components: {
    GridComponent,
    DetailsComponent
  },
  props: {
    invoiceObj: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      gridId: GRID_ID.PAYMENT_INFO,
      fields: gridFields,
      okButtonDisabled: false,
      deleteBtnDisabled: false,
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
      },
      paymentObj: {
        id: 0,
        paymentDate: null,
        paymentMethodId: 0,
        amount: 0,
        referenceNumber: null,
        totalExpenses: 0,
        totalReceived: 0,
        totalCredits: 0,
        comments: null,
      },
      isGettingDetails: true,
      expenseObj:{
        id: 0,
        sourceId: 4,
        referenceId: 0,
        accountId: null,
        amount: 0,
        description: null,
        expenseDate: null,
        active: true,
      },
      chartOfAccounts: [],
    }
  },
  computed: {
    ...mapGetters('lookup', ['paymentMethods']),
    ...mapGetters('receivePayments', ['invoicePaymentLines', 'receivePayment']),
    itemData() {
      return this.invoicePaymentLines;
    }
  },
  methods: {
    ...mapActions('receivePayments', [ 'create', 'getById', 'deleteById', 'getPaymentLinesByInvoice' ]),
    ...mapActions('invoices', { getInvoiceById: 'getById' }),
    ...mapActions('expenses', ['getChartOfAccounts']),
    openPaymentsModal() {
      if (this.invoiceObj != null) {
        this.setDefaults();
      };
      this.$refs['payments-modal'].show();
    },
    setDefaults() {
      this.paymentObj = {
        id: 0,
        companyId: this.invoiceObj.companyId || 0,
        paymentDate: null,
        paymentMethodId: 0,
        amount: this.invoiceObj.balance || 0,
        referenceNumber: null,
        totalExpenses: 0,
        totalReceived: 0,
        totalCredits: 0,
        comments: null,
      };
    },
    generatePaymentLine() {
      return [{
        id: 0,
        invoiceId: this.invoiceObj.id || 0,
        paymentAmount: this.paymentObj.amount,
        creditAmount: 0,
        amount: this.paymentObj.amount,
        balance: this.invoiceObj.balance || 0,
        active: true,
      }];
    },
    async addPayment(e) {

      this.$v.paymentObj.$touch();
      this.$v.expenseObj.$touch();
      if (this.$v.paymentObj.$invalid || this.$v.expenseObj.$invalid) {
        e.preventDefault();
        return;
      }

      let expenses = [];
      this.expenseObj.expenseDate = this.paymentObj.paymentDate

      expenses.push(this.expenseObj);

      let formData = {
        ...this.paymentObj,
        totalReceived: this.paymentObj.amount,
        active: true,
        lines: this.generatePaymentLine(),
        // since we are only dealing with payments here,
        // we are commenting expenses and credits
        expenses: expenses,
        // creditMemoTransactions: []
      };

      try {
        this.okButtonDisabled = true;
        this.create(formData).then(() => {
          this.setDefaults();
          this.getInvoiceById(this.invoiceObj.id);
          this.getPaymentLinesByInvoice(this.invoiceObj.id);
          // this.$emit('updatePayment');
          this.okButtonDisabled = false;
        });
      } catch {
        this.okButtonDisabled = false;
      }
    },
    async onDeletingPaymentLine(paymentLine) {
      this.isGettingDetails = true;
      this.$refs['delete-payments-modal'].show();
      await this.getById(paymentLine.paymentId).then(() => this.isGettingDetails = false);
    },
    async deletePayment() {
      if (this.receivePayment) {
        this.deleteBtnDisabled = true;
        await this.deleteById(this.receivePayment.id).then(() => {
          this.deleteBtnDisabled = false;
          this.$emit('updatePayment');
          this.setDefaults();
          this.getInvoiceById(this.invoiceObj.id);
          this.getPaymentLinesByInvoice(this.invoiceObj.id);
        });;
      }
    }
  },
  watch: {
    invoiceObj() {
      if (this.invoiceObj.id > 0) {
        this.getPaymentLinesByInvoice(this.invoiceObj.id);
      }
    }
  },
  validations: {
    paymentObj: {
      paymentDate: { required },
      paymentMethodId: {required},
      amount: {required }
    },
    expenseObj: {
      accountId: { required },
      amount: { required, decimal, numberGreaterThan: numberGreaterThan(0) },
    }
  },
  async mounted() {
    this.getChartOfAccounts(7).then((result) => this.chartOfAccounts = result);
  }
}
</script>